export const API_EXTERNAL_ENDPOINT = 'cottages/:id/closed-dates'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/detail/closed-dates'
